import routes from 'config/routes'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

function NeedsAuth(props) {
  if (props.authenticated) {
    return <Redirect to={routes.dashboard} />
  }

  return (
    <Row>
      <Col md={8} lg={6} className="mx-auto mt-3">
        <Card>
          <Card.Body>
            <Card.Title>LOGIN</Card.Title>
            <Card.Text>
              This tool is available to BJA members only. To access the results
              tracker, please sign in to your BJA account.
            </Card.Text>
            <div className="text-center font-weight-bold">
              <a href="https://members.blackjackapprenticeship.com">
                https://members.blackjackapprenticeship.com
              </a>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

NeedsAuth.propTypes = {
  authenticated: PropTypes.bool.isRequired,
}

const mapState = state => ({
  authenticated: state.auth.authenticated,
})

export default connect(mapState)(NeedsAuth)
